import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

const BADGE_COLORS = {
  0: 'text-gray-400',
  150: 'text-amber-600',
  350: 'text-gray-300',
  550: 'text-yellow-400',
  750: 'text-cyan-300',
  900: 'text-purple-300',
};

function getScoreColor(score) {
  if (score >= 900) return BADGE_COLORS[900];
  if (score >= 750) return BADGE_COLORS[750];
  if (score >= 550) return BADGE_COLORS[550];
  if (score >= 350) return BADGE_COLORS[350];
  if (score >= 150) return BADGE_COLORS[150];
  return BADGE_COLORS[0];
}

export default function BountyCard({ task }) {
  const slotsRemaining = task.max_agents - (task.current_agents || 0);

  return (
    <Link
      to={`/bounties/${task.task_id}`}
      state={{ task }}
      data-testid={`bounty-card-${task.task_id}`}
      className="block rounded-xl border border-[hsl(var(--border))] bg-[hsl(var(--card))]/80 p-4 hover:border-emerald-500/30 transition-colors group"
    >
      <div className="flex justify-between items-start mb-2">
        <h3 className="font-medium text-[hsl(var(--foreground))] text-sm leading-tight flex-1">{task.title}</h3>
        <span className="text-emerald-400 font-bold text-lg ml-3">${task.bounty_usdc}</span>
      </div>
      <div className="flex flex-wrap gap-2 mb-3">
        <span className="text-xs px-2 py-0.5 rounded-full bg-blue-500/20 text-blue-400 border border-blue-500/30">{task.task_type}</span>
        {task.tags?.slice(0, 3).map(tag => (
          <span key={tag} className="text-xs px-2 py-0.5 rounded-full bg-[hsl(var(--secondary))]/50 text-[hsl(var(--muted-foreground))]">{tag}</span>
        ))}
      </div>
      <div className="flex justify-between items-center text-xs text-[hsl(var(--muted-foreground))]">
        <span>{slotsRemaining} slot{slotsRemaining !== 1 ? 's' : ''} open</span>
        <span className={getScoreColor(task.required_score)}>min: {task.required_score}</span>
        {task.deadline && <span>Due: {new Date(task.deadline).toLocaleDateString()}</span>}
        <ChevronRight className="w-4 h-4 opacity-0 group-hover:opacity-60 transition-opacity" />
      </div>
    </Link>
  );
}
